import { ActionIcon } from '@mantine/core';
import MoreVertIcon from '../../components/icons/MoreVert';
import { useToggle } from '@mantine/hooks';
import { BNAccordionMenu } from '../../components/Accordion/BNAccordion';
import WarningIcon from '../../components/icons/Warning';
import { Sale } from './Sales.types';
import {
  BrokerNerdsBarkerCoreModelsInventoryEvent,
  BrokerNerdsBarkerCoreModelsSalesDtiPortalFulfillmentStatus,
  BrokerNerdsBarkerCoreModelsSalesListingSoldVendorPropertiesDtiPortal,
} from '../../api';
import { useSetAtom } from 'jotai';
import { selectedSaleAtom } from '../../data/atoms';
import ScreenshotIcon from '../../components/icons/Screenshot';
import { isDtiHosted } from '../../utils/whitelabel-consts';
import HistoryIcon from '../../components/icons/History';
import { BarkerEventListing } from '../../types';
import { StringWithPipe } from '../../ts-utils';
import OpenNewIcon from '../../components/icons/OpenNew';
import dayjs from 'dayjs';

export type SaleActionProps = {
  sale: Sale;
  setSelectedHistoryListing: (value: { listing: BarkerEventListing; isOpen: boolean }) => void;
};
export const SalesAction = ({ sale, setSelectedHistoryListing }: SaleActionProps) => {
  const [menuOpen, toggleMenu] = useToggle();

  return (
    <>
      <BNAccordionMenu
        width={200}
        opened={menuOpen}
        onClose={() => toggleMenu(false)}
        position="right"
        offset={15}
        target={
          <ActionIcon onClick={() => toggleMenu()}>
            <MoreVertIcon size={20} color="var(--colors-gray-5)" />
          </ActionIcon>
        }
      >
        {menuOpen && <SalesActionForm sale={sale} setSelectedHistoryListing={setSelectedHistoryListing} toggleMenu={toggleMenu} />}
      </BNAccordionMenu>
    </>
  );
};

export const SalesActionForm = ({ sale, setSelectedHistoryListing, toggleMenu: _toggleMenu }: SaleActionProps & { toggleMenu: (value?: boolean) => void }) => {
  const vendorProperties = sale.vendorProperties as BrokerNerdsBarkerCoreModelsSalesListingSoldVendorPropertiesDtiPortal;
  const fulfillmentStatus = sale.fulfillmentStatus as BrokerNerdsBarkerCoreModelsSalesDtiPortalFulfillmentStatus;

  const isEligibleForAirbill =
    sale.vendorProperties?.pointOfSaleId === 'DtiPortal' &&
    !vendorProperties.hasAirbill &&
    fulfillmentStatus.status === 'Incomplete' &&
    (vendorProperties.location === 'HARD' || vendorProperties.location === 'DROPSHIP');

  const isEligibleForSelfService =
    sale.vendorProperties?.pointOfSaleId === 'DtiPortal' &&
    fulfillmentStatus.status === 'Incomplete' &&
    (vendorProperties.location === 'MOBILE_XFR' || vendorProperties.location === 'FLASH');

  const setSelectedSale = useSetAtom(selectedSaleAtom);

  return (
    <>
      {isDtiHosted && (
        <BNAccordionMenu.Item
          title="Complete Self-Service"
          leftSection={<ScreenshotIcon />}
          disabled={!isEligibleForSelfService}
          onClick={() => setSelectedSale(sale)}
          data-pendo-name="Complete Self-Service MenuItem"
        />
      )}
      {isDtiHosted && (
        <BNAccordionMenu.Item
          title="Request Airbill"
          leftSection={<WarningIcon />}
          disabled={!isEligibleForAirbill}
          onClick={() => {}}
          data-pendo-name="Request Airbill MenuItem"
        />
      )}
      <BNAccordionMenu.Item
        title="View History"
        leftSection={<HistoryIcon />}
        onClick={() => {
          if (!sale?.event?.venue) return;

          const listing = {
            ...sale,
            tenantIdListingId: `${sale.tenantId}|${sale.listingId}` as StringWithPipe,
            tenantIdEventId: `${sale.tenantId}|${sale.event.eventId}` as StringWithPipe,
            isBroadcasting: false,
            quantityRemaining: sale.quantity,
            quantityReserved: 0,
            pricerStatusId: 'None',
            numBarcodes: 0,
            seatingType: 'Unknown',
            unitFace: 0,
            event: {
              ...sale.event,
              venue: { ...sale.event.venue, tenantId: sale.tenantId },
              links: [],
              numComments: 0,
              numTicketsSold: 0,
              monitors: [],
              openCost: 0,
              openListings: 0,
              openTickets: 0,
              tenantId: sale.tenantId,
            } satisfies BrokerNerdsBarkerCoreModelsInventoryEvent,
          } satisfies BarkerEventListing;
          setSelectedHistoryListing({ listing, isOpen: true });
        }}
        data-pendo-name="Sales - View Listing History MenuItem"
      />
      <BNAccordionMenu.Item
        title="Open Event"
        leftSection={<OpenNewIcon />}
        onClick={() => {
          if (!sale?.event) return;

          const isEventDateInPast = new Date(sale.event.localDateTime).getTime() < new Date().getTime();

          if (isEventDateInPast) {
            window.open(`/?fromDate=${dayjs(sale.event.localDateTime).format('YYYY-MM-DD')}&eventId=${sale.event.eventId}`, '_blank');
          } else {
            window.open(`/?eventId=${sale.event.eventId}`, '_blank');
          }
        }}
        data-pendo-name="Sales - Open Event MenuItem"
      />
    </>
  );
};

// export const UploadTransferProofModal = ({ sale, closeModal }: { sale: Sale; closeModal: () => void }) => {
//
//   const { mutateAsync: uploadTransferProof } = usePostApiSalesSaleIdUploadTransferProof();
//
//   return (
//
//   )
// };
